import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface TabValue {
    tab: number
}
interface SideBarValue {
  name: string,
  option: number | null,
  drawerOpen: boolean
}
  
const timesheetTabState: TabValue= {
    tab: 0
}

const backofficeTabState: TabValue= {
  tab: 0
}

const sideBarState: SideBarValue  = {
  name: '',
  option: 0,
  drawerOpen: false
}

export const timesheetTabsSlice = createSlice({
    name: 'timesheetTabs',
    initialState: timesheetTabState,
    reducers: {
      changeTab: (state, action: PayloadAction<TabValue>) => {
        state.tab = action.payload.tab
      }
    }
});

export const backofficeTabsSlice = createSlice({
  name: 'backofficeTabs',
  initialState: backofficeTabState,
  reducers: {
    changeBackofficeTab: (state, action: PayloadAction<TabValue>) => {
      state.tab = action.payload.tab
    }
  }
});

export const sideBarSlice = createSlice({
  name: 'sideBar',
  initialState: sideBarState,
  reducers: {
    changeOption: (state, action: PayloadAction<SideBarValue>) => {
      state.option = action.payload.option
      state.name = action.payload.name
    },
    toggleDrawer: (state) => {
      state.drawerOpen = !state.drawerOpen
    },
    setDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.drawerOpen = action.payload
    }
  }
});

export const { changeTab } = timesheetTabsSlice.actions
export const { changeBackofficeTab } = backofficeTabsSlice.actions

export const { changeOption, toggleDrawer, setDrawerOpen } = sideBarSlice.actions
